import { useState, useEffect } from 'react';

import { Container, } from '@material-ui/core';

import api from '../../services/api'

import CorpoChamadoUnico from '../../components/Chamados/chamadoUnico';
import NavBar from '../../components/NavBar/NavBar';


function MainDashboard() {
  const [body, setBody] = useState([]);
  const id = localStorage.getItem('id');


  useEffect(() => {
    api.get('/chamados/unico?id=' + id)
      .then(({ data, }) => {
        setBody(data);
      });
  }, []);


  return (
    <div id="div-1">
      <NavBar>
        <Container maxWidth='xl'>
          <br />
          {
            body
              .map((body) => {
                return <CorpoChamadoUnico key={body.id} data={body} />;
              })
          }
        </Container>
      </NavBar>
    </div>
  );
}

export default MainDashboard;
